import { FC } from "react";
import { useHistory } from "react-router-dom";
import Button from "../../Button";

interface IProps {
  text: string;
  path: string;
}

const Subtitle: FC<IProps> = ({
  text,
  path,
}) => {
  const history = useHistory();

  return (
    <div className='comm-bx__between'>
      <h3 className='sub-title'>{text}</h3>
      <div className='comm-btn__area'>
      <Button
        className="btn-basic pink"
        text="More"
        onClick={() => history.push(path)}
      />
      </div>
    </div>
  );
}

export default Subtitle;
